import { Component, OnInit } from "@angular/core";
import { DatatableConfig } from "src/app/config/DatatableConfig";
import { ReporteEstadoSeccionesService } from "src/app/services/reporte-estado-secciones/reporte-estado-secciones.service";
import {
  IListaAnhos,
  IListaPeriodos,
  IListaAsignaturas,
} from "src/app/interfaces/ponderaciones";
import { PerfilamientoService } from "src/app/services/perfilamiento/perfilamiento.service";
import { ISedes } from "src/app/interfaces/auditoria";
import {
  IListaJornadas,
  IListaReportes
} from "src/app/interfaces/reporte-estado-secciones";
import { FormBuilder, FormControl } from "@angular/forms";
import {
  Observable,
  debounceTime,
  distinctUntilChanged,
  map,
  startWith,
} from "rxjs";
import { IEstados } from 'src/app/interfaces/secciones';
import { saveAs } from 'file-saver';
import { UtilsFnService } from "src/app/services/utils/utils-fn.service";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: "app-view-reporte-estado-secciones",
  templateUrl: "./view-reporte-estado-secciones.component.html",
  styleUrls: ["./view-reporte-estado-secciones.component.scss"],
})
export class ViewReporteEstadoSeccionesComponent implements OnInit {
  dtOptions: DataTables.Settings | any = { ...DatatableConfig.dtOptionsWithPopOver };

  filtroAnyos: Array<number> = [];
  filtroPeriodos: Array<any> = [];
  filtroSedes: Array<any> = [];
  filtroAsignaturas: Array<any> = [];
  filtroEstados: Array<any> = [];
  filtroJornadas: Array<any> = [];

  tieneErrores: any = {};
  filtroAnyoSeleccionado: number = 0;
  filtroPeriodoSeleccionado: number = 0;
  filtroSedeSeleccionado: number = 0;
  filtroAsignaturaSeleccionado: number = 0;
  filtroEstadoSeleccionado: number = 0;
  filtroJornadaSeleccionada: number = 0;
  filtroCodigoAsignaturaSeleccionado: string = "";

  submitted: boolean = false;
  reporteEnProceso: boolean = false;
  habilitarBtnGenerarReporte: boolean = false;
  rolUsuario: number | null = null;

  renderTabla: boolean = true;
  listaReportes: Array<any> = [];
  funcionIntervalo: any;
  searchAsignaturaForm = new FormControl("");
  filteredAsignatura: Observable<Array<any>>;

  error: string = "";
  cargaInicial: boolean = true

  parametrosForm = this.formBuilder.group({
    asignatura: [""],
  });

  constructor(
    private _reporte: ReporteEstadoSeccionesService,
    private _perfilamiento: PerfilamientoService,
    private formBuilder: FormBuilder,
    private _utilsFn: UtilsFnService,
    private spinner: NgxSpinnerService
  ) {
    let user = this._perfilamiento.getUsuario();
    this.rolUsuario = user.rolId;

    this.filteredAsignatura = this.searchAsignaturaForm.valueChanges.pipe(
      startWith(""),
      map((value) => this._filter(value || "", "asignatura"))
    );

    this.searchAsignaturaForm.valueChanges.pipe(
      debounceTime(400),
      distinctUntilChanged()
    )
      .subscribe(res => {
        this.tieneErrores["asignatura"] = false;
        if (typeof res === 'object') {
          let id = this.obtenerId(res)
          let codigo = this.obtenerCodigo(res);
          this.filtroAsignaturaSeleccionado = id
          this.filtroCodigoAsignaturaSeleccionado = codigo;
        } else {
          this.filtroCodigoAsignaturaSeleccionado = "";
          this.filtroAsignaturaSeleccionado = 0;
        }
      })
  }

  ngOnInit(): void {
    this.dtOptions = { ...DatatableConfig.dtOptionsWithPopOver };
    this.dtOptions.order = [[0, "desc"]];
    this.dtOptions.lengthMenu = [10, 20, 30, 40, 50];

    this.getAnyos();
    this.getSedes();
    this.getEstados();
    this.getJornadas();
    this.actualizarTabla();
  }

  actualizarTabla(): void {
    this.funcionIntervalo = setInterval(() => {
      if (document.visibilityState === 'visible' && this.reporteEnProceso) {
        this.busqueda();
      }
    }, 35000);
  }
  ngOnDestroy(): void {
    clearInterval(this.funcionIntervalo);
  }

  seleccionFiltro(filtro: string): void {
    switch (filtro) {
      case "anyo":
        this.limpiarFiltros("anyo");
        this.tieneErrores["anyo"] = false;
        this.getPeriodos();
        this.habilitarBtnGenerarReporte = this.activarBtnGenerar();
        break;
      case "periodo":
        this.limpiarFiltros("periodo");
        this.tieneErrores["periodo"] = false;
        if (this.rolUsuario != 2) {
          this.getListaSiglaAsignatura();
        }
        this.habilitarBtnGenerarReporte = this.activarBtnGenerar();
        break;
      case "sede":
        this.limpiarFiltros("sede");
        this.tieneErrores["sede"] = false;
        this.tieneErrores["asignatura"] = false;
        this.getListaSiglaAsignatura();
        this.habilitarBtnGenerarReporte = this.activarBtnGenerar();
        break;
      case "jornada":
        this.limpiarFiltros("jornada");
        this.tieneErrores["jornada"] = false;
        this.tieneErrores["asignatura"] = false;
        this.getListaSiglaAsignatura();
        this.habilitarBtnGenerarReporte = this.activarBtnGenerar();
        break;
      default:
        break;
    }
  }

  casePeriodoSedeJornada() {
    this.filtroAsignaturaSeleccionado = 0;
    this.filtroAsignaturas = [];
    this.searchAsignaturaForm.setValue("");
  }

  limpiarFiltros(filtro: string): void {
    this.reporteEnProceso = false;
    switch (filtro) {
      case "anyo":
        this.filtroPeriodoSeleccionado = 0;
        this.filtroAsignaturaSeleccionado = 0;
        this.filtroPeriodos = [];
        this.filtroAsignaturas = [];
        this.searchAsignaturaForm.setValue("");
        break;
      case "periodo":
        this.casePeriodoSedeJornada()
        break;
      case "sede":
        this.casePeriodoSedeJornada()
        break;
      case "jornada":
        this.casePeriodoSedeJornada()
        break;
      default:
        this.filtroAnyoSeleccionado = 0;
        this.filtroPeriodoSeleccionado = 0;
        this.filtroSedeSeleccionado = 0;
        this.filtroAsignaturaSeleccionado = 0;
        this.filtroPeriodos = [];
        this.filtroAsignaturas = [];
        this.filtroJornadaSeleccionada = 0;
        this.filtroEstadoSeleccionado = 0;
        this.searchAsignaturaForm.setValue("");
        this.submitted = false;
        this.tieneErrores["anyo"] = false;
        this.tieneErrores["periodo"] = false;
        this.tieneErrores["sede"] = false;
        this.tieneErrores["asignatura"] = false;
        this.renderTabla = true;
        setTimeout(() => {
          this.renderTabla = false;
        }, 50);
        this.listaReportes = [];
        this.habilitarBtnGenerarReporte = this.activarBtnGenerar();
        break;
    }
  }

  activarBtnGenerar(): boolean {
    if (this.rolUsuario === 2) {
      if (
        this.filtroAnyoSeleccionado == 0 ||
        this.filtroPeriodoSeleccionado == 0 ||
        this.filtroSedeSeleccionado == 0
      ) {
        return false;
      }
    }
    if (
      this.filtroAnyoSeleccionado == 0 ||
      this.filtroPeriodoSeleccionado == 0
    ) {
      return false;
    }
    return true;
  }

  getAnyos(): void {
    this._reporte.getFiltrosAnhos().subscribe(
      (res: IListaAnhos) => {
        this.filtroAnyos = res.anyos;
      },
      (err: any) => {}
    );
  }

  getEstados(): void {
    this._reporte.getFiltrosEstados().subscribe(
      (res: IEstados) => {
        this.filtroEstados = res.estados;
      },
      (err: any) => {}
    );
  }

  getPeriodos(): void {
    if (this.filtroAnyoSeleccionado != 0) {
      this._reporte
        .getFiltrosPeriodos(this.filtroAnyoSeleccionado)
        .subscribe((res: IListaPeriodos) => {
          this.filtroPeriodos = res.periodos;
        });
    }
  }

  getJornadas(): void {
      this._reporte
        .getFiltrosJornadas()
        .subscribe((res: IListaJornadas) => {
          this.filtroJornadas = res.jornadas;
        });
  }

  getSedes(): void {
    let usuario = this._perfilamiento.getUsuario();
    this._reporte.getFiltrosSedes(usuario.usuarioId).subscribe({
      next: (res: ISedes) => {
        this.filtroSedes = res.sedes;
      },
    });
  }

  getListaSiglaAsignatura() {
    if (
      this.filtroAnyoSeleccionado != null &&
      this.filtroPeriodoSeleccionado != null
    ) {
      this.searchAsignaturaForm.setValue("");
      this._reporte
        .getFiltrosAsignaturas(
          this.filtroAnyoSeleccionado,
          this.filtroPeriodoSeleccionado,
          this.filtroSedeSeleccionado
        )
        .subscribe({
          next: (res: IListaAsignaturas) => {
            this.filtroAsignaturas = res.asignaturas;
          }
        });
    }
  }

  displayFn(objeto: any): string {
    if (objeto?.codigo) {
      return objeto?.codigo
        ? objeto.codigo.replace(/\w\S*/g, (w: string) =>
            w.replace(/^\w/, (c) => c.toUpperCase())
          )
        : "";
    } else {
      return objeto && String(objeto.id)
        ? String(objeto.id).replace(/\w\S*/g, (w: string) =>
            w.replace(/^\w/, (c) => c.toUpperCase())
          )
        : "";
    }
  }

  private _filter(value: string, filtro: string) {
    if (typeof value != "string") {
      return [];
    }
    const filterValue = this._normalizeValue(value);
    if (filtro == "asignatura") {
      return this.filtroAsignaturas.filter(
        (asignatura: { id: number; codigo: string }) =>
          this._normalizeValue(asignatura?.codigo)?.includes(filterValue)
      );
    }
    return [];
  }

  private _normalizeValue(value: string): string {
    return value
      ?.toLowerCase()
      ?.normalize("NFD")
      ?.replace(/[\u0300-\u036f]/g, "");
  }

  fnNoTieneErrores(noTieneErrores: boolean = false): boolean {
    if ( this.filtroAnyoSeleccionado != 0 && this.filtroPeriodoSeleccionado != 0 ) {
      noTieneErrores = true
      if (this.rolUsuario === 2 && this.filtroSedeSeleccionado == 0) {
        noTieneErrores = false
      }
    }

    if (this.filtroAnyoSeleccionado == 0) {
      this.tieneErrores["anyo"] = true;
    }
    if (this.filtroPeriodoSeleccionado == 0) {
      this.tieneErrores["periodo"] = true;
    }
    if (this.filtroSedeSeleccionado == 0 && this.rolUsuario === 2) {
      this.tieneErrores["sede"] = true;
    }
    return noTieneErrores
  }

  fnTieneErroresAutoCompletado(errorEnAutoCompletado: boolean = false): any {
    let noTieneErrores = this.fnNoTieneErrores()
    if (typeof this.searchAsignaturaForm.value !== 'object' && this.searchAsignaturaForm.value != "") {
      noTieneErrores = false;
      errorEnAutoCompletado = true;
      this.tieneErrores["asignatura"] = true;
    }

    if (errorEnAutoCompletado) {
      this.error = "Debe seleccionar un ítem de la lista";
      this.limpiarError();
    }
    return { noTieneErrores, errorEnAutoCompletado }
  }

  reiniciarDt(idTabla: string, dtOptions: any): void {
    if ($.fn.dataTable.isDataTable(`#${idTabla}`)) {
      $(`#${idTabla}`).DataTable().destroy();
    }
    setTimeout(() => {
      $(`#${idTabla}`).DataTable(dtOptions);
    }, 350); 
  }

  busqueda(): void {
    this.submitted = true;
    const { noTieneErrores } = this.fnTieneErroresAutoCompletado()
    
    if (noTieneErrores) {
      if ( this.renderTabla ) {
        this.renderTabla = false;
        this.reiniciarDt('tabla-estado-secciones', this.dtOptions)
      }
      this.renderTabla = true;

      if ( this.cargaInicial ) {
        this.spinner.show()
      }
      // Datatable serverside
      this.dtOptions.serverSide = true
      this.dtOptions.pageLength = 10
      this.dtOptions.processing = true
      this.dtOptions.ajax = (dataTablesParameters: any, callback: any) => { 
        let paramsTableBody = {
          pageSize: dataTablesParameters.length,
          pageNumber: (dataTablesParameters.start / dataTablesParameters.length)+1
        }
        const busquedaTabla: string = dataTablesParameters.search.value
        this._utilsFn.agregarLoader('tabla-estado-secciones')
        const body = this.fnBody({
          search: busquedaTabla,
          pageSize: paramsTableBody.pageSize,
          pageNumber: paramsTableBody.pageNumber,
        })
        this._reporte.obtenerListadoReportes(body).subscribe({
          next: (res: any) => {
            this.reporteEnProceso = false;
            if (res.error == null) {
              this.listaReportes = res.listado;
              this.listaReportes.forEach(reporte => {
                if (reporte.estadoProceso == "EP") {
                  this.reporteEnProceso = true;
                }
              })
              callback({
                recordsTotal: res.totalItems,
                recordsFiltered: res.totalItems,
                data:[]
              })

              this._utilsFn.eliminarLoader('tabla-estado-secciones')
              if ( this.cargaInicial ) {
                this.spinner.hide()
                this.cargaInicial = false
              }

              if ( this.listaReportes.length > 0 ) {
                setTimeout(() => {
                  const emptyElement = document.querySelector('#tabla-estado-secciones_wrapper .dataTables_empty');
                  emptyElement?.setAttribute('style', 'display: none');
                }, 50);
              }
  
              setTimeout(() => {
                $("#tabla-estado-secciones").DataTable().columns.adjust();
              }, 180);
            }
          }
        })
      }
      // Fin Datatable serverside
    }
  }

  fnBody(dataTable: any = null): any {
    return {
      anyo: this.filtroAnyoSeleccionado,
      periodoId: this.filtroPeriodoSeleccionado,
      sedeId:
        this.filtroSedeSeleccionado != 0 ? this.filtroSedeSeleccionado : null,
      tpoJornadaId:
        this.filtroJornadaSeleccionada != 0
          ? this.filtroJornadaSeleccionada
          : null,
      asignaturaId:
        this.filtroAsignaturaSeleccionado != 0
          ? this.filtroAsignaturaSeleccionado
          : null,
      estadoId:
        this.filtroEstadoSeleccionado != 0
          ? this.filtroEstadoSeleccionado
          : null,
      
      // Datatable params
      ...(dataTable?.search ? { search: dataTable.search } : {}),
      ...(dataTable?.pageSize ? { pageSize: dataTable.pageSize } : {}),
      ...(dataTable?.pageNumber ? { pageNo: dataTable.pageNumber } : {})
    };
  }

  generarSolicitudReporte(): void {
    this.submitted = true
    const { noTieneErrores } = this.fnTieneErroresAutoCompletado()

    if (noTieneErrores) {
      let body = this.fnBody()
      this._reporte.generarSolicitudReporte(body).subscribe({
        next: (res: IListaReportes) => {
          this.reporteEnProceso = false;
          if (res.error != null) {
            this.error = res.error.mensaje;
            this.limpiarError();
          } else {
            this.busqueda();
          }
        }
      })
    }
  }

  obtenerReporte(idSolicitud: number): void {
    this._reporte.obtenerReporte(idSolicitud).subscribe(
        async (res: any) => {
        const contentDispositionHeader = res?.headers?.get('Content-Disposition')
        const fileName = contentDispositionHeader?.split(';')[1]?.trim()?.split('=')[1]
        const bufferPromise = await res?.body.arrayBuffer();
        const csvData = new Blob([new Uint8Array([0xEF, 0xBB, 0xBF]), bufferPromise], {type: "text/plain;charset=utf-8"});
        saveAs(csvData, fileName?.replace(/"/g, '') ?? 'reporteEstadoSeccion.csv')
      }
    );
  }

  limpiarError(): void {
    setTimeout(() => {
      this.error = "";
    }, 10000);
  }

  obtenerId(objeto: any): number {
    if(objeto.id){
      return objeto.id;
    }else{
      return objeto.docenteId
    }
  }
  obtenerCodigo(objeto: any): string {
      return objeto.codigo;
  }
}
